import React, { useEffect, useState } from "react"
import Layout from "components/layout"
import SEO from "components/seo"
import Image from "components/image"
import { navigate } from "gatsby"
import styles from "../assets/style/feature.module.scss"

const bankingModules = [
  {
    title: "Loan Products",
    content:
      "WoodCore provides you with the flexibility to create various loan products that supports all standard interest calculation methods, the ability to schedule any irregular or non-traditional financing deals and much more.",
  },
  {
    title: "Deposit Products",
    content:
      "Provide your customers with a range of deposit products that will allow them to grow or increase their initial deposit. WoodCore provides your employees with higher productivity and saved time for value-added customer service.",
  },
  {
    title: "Fixed Products",
    content:
      "Easily provide your customers with various plans for fixing their deposit with your institution. WoodCore is fully automated giving you control over the process. State your conditions & let WoodCore do the rest of the job.",
  },
]

const chargeModules = [
  {
    title: "Overdraft Charge",
    content:
      "Use WoodCore to implement an overdraft charge and configure specific conditions that suit your organization.",
  },
  {
    title: "Deposit Charge",
    content:
      "Automate the process of charges on deposit accounts or products. WoodCore allows you configure when a charge should be made and how it should be recorded is automated.",
  },
  {
    title: "NIP or Interswitch Charge",
    content:
      "Pre configure all kinds of charges, NIP, Card, Overdraft and any relevant charges applied to customers account.",
  },
  {
    title: "NIP or Interswitch Charge",
    content:
      "The life cycle of a loan can be fully automated and seamless with the help of WoodCore. While you have set configurations in place, WoodCore will ensure the right actions are taken on loans disbursed to your customer.",
  },
]

const externalIntegrations = [
  {
    title: "NIP Transfer",
    content:
      "Integrating with our transfer service provides you with the seamlessness you need. Your customers will be able to perform inter-bank transfers and you do not have to integrate with another service for this. Think this, Woodcore is everything your bank needs to run efficiently.",
  },
  {
    title: "SMS Notification",
    content:
      "Woodcore provides you with an SMS notification service which can be utilized for your customers. A friendly rate for transfer alerts, OTP and other SMS notifications.",
  },
  {
    title: "Bank Verification Number",
    content:
      "We provide you with an all in one solution that can also be utilized to verify the identity of your customers without depending on any third party service.",
  },
]

const accountingModules = [
  {
    title: "Chart of Account",
    content:
      "Put a structure around your entries. WoodCore provides you with a configurable chart of account which will aid how entries are being posted in your organization.",
  },
  {
    title: "Journal Entries",
    content:
      "WoodCore provides you with options for your journal entry. Whether you like to keep it manual or fully/partly automated.",
  },
  {
    title: "Accounting Rule",
    content:
      "Put accounting rules in place that will guide how debit and credit accounts available for posting transactions are defined.",
  },
  {
    title: "Accrual Accounting",
    content:
      "Configure your back office to allow accrual accounting and let WoodCore manage the rest of the process, even after there is cashflow.",
  },
]

const FeaturesPage = () => {
  const [top, setTop] = useState(false)
  const [bottom, setBottom] = useState(false)
  const [mid, setMid] = useState(false)
  const [activateAnimation, setActivateAnimation] = useState(false)

  useEffect(() => {
    const mainTopObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setActivateAnimation(true)
          }
        })
      },
      {
        root: null,
        threshold: 0.9,
      }
    )
    const topObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setMid(false)
            setTop(true)
            setBottom(false)
          }
        })
      },
      {
        root: null,
        threshold: 0.02,
      }
    )

    const midObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setMid(true)
            setBottom(false)
            setTop(false)
          }
        })
      },
      {
        root: null,
        threshold: 0.8,
      }
    )

    const bottomObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setBottom(true)
            setTop(false)
            setMid(false)
          }
        })
      },
      {
        root: null,
        threshold: 0.03,
      }
    )
    mainTopObserver.observe(document.querySelector("#top"))
    topObserver.observe(document.querySelector("#top"))
    midObserver.observe(document.querySelector("#mid"))
    bottomObserver.observe(document.querySelector("#bottom"))
  })

  return (
    <Layout active="features" bottomInfo={false}>
      <SEO title="Product Features" />
      <section>
        <div className="bg-snow-100 flex items-center justify-center relative">
          <div className="mx-auto w-11/12 md:w-10/12 xl:w-8/12 text-center">
            <div className="h-32 w-full"></div>
            <h1
              className="text-grey-100 font-bold text-5xl w-10/12 mx-auto shortFadeIn"
              style={{ lineHeight: "62px" }}
            >
              Product Features
            </h1>
            <h2
              className="text-grey-200 tracking-xs mt-4 md:w-9/12 mx-auto shortFadeIn delay-300ms"
              style={{ lineHeight: "30px", fontSize: "15px" }}
            >
              WoodCore is a modularized core banking system, completely
              decentralized with diverse functionalities to simplify banking and
              financial activities within a softwares
            </h2>
            <div className="h-32 w-full"></div>
          </div>
        </div>
      </section>

      <section id="top">
        <div className="flex flex-col-reverse lg:flex-row items-center w-11/12 lg:w-10/12 xl:w-9/12 mx-auto my-24">
          <div className="lg:w-3/5 w-full">
            <div className="md:w-10/12 mx:auto lg:mx-0 mt-5 lg:mt-0">
              <h3
                style={{ fontSize: "28px" }}
                className="font-bold text-grey-100"
              >
                Customer &amp; Account Module
              </h3>
              <p
                style={{ fontSize: "16.7px", lineHeight: "32px" }}
                className="text-base text-grey-200 mt-1 lg:w-11/12 xl:w-10/12"
              >
                WoodCore provides your company with a 360 degree view of your
                customers to ensure that your customers satisfaction is
                maintained at high levels throughout the organization with every
                customer interaction so that your company's revenue and
                profitability goals are met or exceeded.
              </p>
              <ul>
                <li
                  className={`flex items-start opacity-0 mt-5 ${
                    activateAnimation ? "shortFadeIn" : ""
                  }`}
                >
                  <div className="mr-2">
                    <img src={require("images/circle.svg")} alt="circle svg" />
                  </div>
                  <p style={{ fontSize: "16.7px" }} className=" w-10/12">
                    Know your customer (KYC)
                  </p>
                </li>
                <li
                  className={`flex items-start opacity-0 mt-3 delay-300ms ${
                    activateAnimation ? "shortFadeIn" : ""
                  }`}
                >
                  <div className="mr-2">
                    <img src={require("images/circle.svg")} alt="circle svg" />
                  </div>
                  <p style={{ fontSize: "16.7px" }} className=" w-10/12">
                    Image and Signatures
                  </p>
                </li>
                <li
                  className={`flex items-start opacity-0 mt-3 delay-500ms ${
                    activateAnimation ? "shortFadeIn" : ""
                  }`}
                >
                  <div className="mr-2">
                    <img src={require("images/circle.svg")} alt="circle svg" />
                  </div>
                  <p style={{ fontSize: "16.7px" }} className=" w-10/12">
                    Country or Regions specific details
                  </p>
                </li>
                <li
                  className={`flex items-start opacity-0 mt-3 delay-700ms ${
                    activateAnimation ? "shortFadeIn" : ""
                  }`}
                >
                  <div className="mr-2">
                    <img src={require("images/circle.svg")} alt="circle svg" />
                  </div>
                  <p style={{ fontSize: "16.7px" }} className=" w-10/12">
                    Customer Charge management
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full lg:w-2/5">
            <div>
              <Image source="smilingMan" />
            </div>
          </div>
        </div>
      </section>

      <section id="mid">
        <div className="lg:flex w-11/12 lg:w-10/12 xl:w-9/12 mx-auto mb-24 relative">
          <div className="w-full lg:w-2/5">
            <div
              className={
                top
                  ? styles.top
                  : bottom
                  ? styles.bottom
                  : mid
                  ? styles.mid
                  : "w-64"
              }
            >
              <div className={styles.image_width}>
                <Image source="smilingWoman" />
              </div>
            </div>
          </div>
          <div className="w-full lg:w-3/5">
            <div className="lg:w-9/12 lg:ml-auto mt-6 lg:mt-2">
              <h3
                style={{ fontSize: "28px" }}
                className="font-bold text-grey-100"
              >
                Account Management Module
              </h3>

              <div className="mt-5">
                <h4
                  className="text-green text-lg font-medium"
                  style={{ fontSize: "20px" }}
                >
                  Deposit Accounts
                </h4>
                <p
                  style={{ fontSize: "16.7px", lineHeight: "32px" }}
                  className="text-base text-grey-200  mt-1 pr-2"
                >
                  Provide your customers with different deposit account types
                  for businesses and individuals in your institution. It just
                  got easier, WoodCore allows you to have a wide range of
                  account deposit account types that can be customized to suit
                  your purpose and dynamically integrate complex calculations to
                  promptly estimate various rates
                </p>
                <ul>
                  <li className="flex items-start mt-5">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p style={{ fontSize: "16.7px" }} className=" w-10/12">
                      Savings Account
                    </p>
                  </li>
                  <li className="flex items-start mt-3">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p style={{ fontSize: "16.7px" }} className=" w-10/12">
                      Current Deposits
                    </p>
                  </li>
                  <li className="flex items-start mt-3">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p
                      style={{ fontSize: "16.7px" }}
                      className="text-base w-10/12"
                    >
                      Corporate Accounts
                    </p>
                  </li>
                  <li className="flex items-start mt-3">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p
                      style={{ fontSize: "16.7px" }}
                      className="text-base w-10/12"
                    >
                      Overdraft Account
                    </p>
                  </li>
                </ul>
              </div>
              <div className="mt-8">
                <h4
                  className="text-green text-lg font-medium"
                  style={{ fontSize: "20px" }}
                >
                  Loan Accounts
                </h4>
                <p
                  className="text-base text-grey-200  mt-1 pr-2"
                  style={{ lineHeight: "32px" }}
                >
                  The whole life cycle of a loan from preparation to when it is
                  posted in the General Ledger till when repayment begins to
                  happen, you have no cause for worries with WoodCore. We let
                  you stay in charge by allowing you to easily modify loan
                  conditions and your loan process.
                </p>
                <ul>
                  <li className="flex items-start mt-5">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p className="text-base w-10/12">Loan Origination</p>
                  </li>
                  <li className="flex items-start mt-3">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p className="text-base w-10/12">Loan Disbursement</p>
                  </li>
                  <li className="flex items-start mt-3">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p className="text-base w-10/12">Loan Management</p>
                  </li>
                  <li className="flex items-start mt-3">
                    <div className="mr-2">
                      <img
                        src={require("images/circle.svg")}
                        alt="circle svg"
                      />
                    </div>
                    <p style={{ fontSize: "16.7px" }} className=" w-10/12">
                      Loan Reconciliation & Repayments
                    </p>
                  </li>
                </ul>
              </div>
              <div className="mt-8">
                <h4
                  className="text-green text-lg font-medium"
                  style={{ fontSize: "20px" }}
                >
                  Deposit Accounts
                </h4>
                <p
                  className="text-base text-grey-200  mt-1 pr-2"
                  style={{ lineHeight: "32px" }}
                >
                  The fixed deposit module, just like the deposit and loan
                  accounts, our system gives you the freedom to make some
                  customizations that suits your organization.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-snow-100" id="bottom">
        <div className="w-11/12 xl:w-9/12 mx-auto py-24">
          <h4
            className="text-grey-100 font-semibold xl:w-7/12 mx-auto text-center"
            style={{ fontSize: "32px" }}
          >
            Banking Products Module
          </h4>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {bankingModules.map((value, i) => (
              <div className="col-span-1" key={value.title}>
                <div className="border border-grey-300 rounded-lg bg-white py-4 px-4 h-full">
                  <div>
                    <div className="h-10 w-10 bg-smoke-100 rounded-full flex items-center justify-center">
                      <p className="text-green text-lg font-medium">{i + 1}</p>
                    </div>
                    <p className="text-lg text-grey-100 font-medium mt-3">
                      {value.title}
                    </p>
                  </div>

                  <p
                    className="mt-4 text-grey-200"
                    style={{ lineHeight: "26px", fontSize: "15px" }}
                  >
                    {value.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section>
        <div className="my-24">
          <h4
            className="text-grey-100 font-semibold text-center"
            style={{ fontSize: "32px" }}
          >
            Charge Management Module
          </h4>
          <div className="w-11/12 lg:w-9/12 xl:w-8/12 xl:px-6 mx-auto grid grid-cols-2 gap-12 mt-10">
            {chargeModules.map(value => (
              <div className="col-span-2 md:col-span-1">
                <h5
                  className="text-green text-lg font-medium"
                  style={{ fontSize: "20px" }}
                >
                  {value.title}
                </h5>
                <p
                  className="text-grey-200 mt-2"
                  style={{ fontSize: "16.7px", lineHeight: "32px" }}
                >
                  {value.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="mb-24 flex lg:flex-row flex-col-reverse w-11/12 lg:w-10/12 xl:w-9/12 mx-auto">
          <div className="w-full lg:w-3/5">
            <div className="xl:w-10/12 mt-4">
              <h3
                style={{ fontSize: "28px" }}
                className="font-bold text-grey-100"
              >
                External Integrations
              </h3>
              {externalIntegrations.map(value => (
                <div className="mt-8">
                  <h4
                    className="text-green text-lg font-medium"
                    style={{ fontSize: "20px" }}
                  >
                    {value.title}
                  </h4>
                  <p
                    className="text-base text-grey-200 lg:w-9/12 mt-4 "
                    style={{ lineHeight: "32px" }}
                  >
                    {value.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-2/5">
            <Image source="externalIntegration" />
          </div>
        </div>
      </section>

      <section className="bg-snow-100">
        <div className="w-11/12 lg:w-9/12 xl:w-7/12 mx-auto py-24">
          <h4
            className="text-grey-100 font-semibold xl:w-7/12 mx-auto text-center"
            style={{ fontSize: "32px" }}
          >
            Accounting Module
          </h4>
          <div className="mt-12 grid md:grid-cols-2 gap-8">
            {accountingModules.map((value, i) => (
              <div className="col-span-1" key={value.title}>
                <div className="border border-grey-300 rounded-lg bg-white py-4 px-4 h-full">
                  <div>
                    <div className="h-10 w-10 bg-smoke-100 rounded-full flex items-center justify-center">
                      <p className="text-green text-lg font-medium">{i + 1}</p>
                    </div>
                    <p className="text-lg text-grey-100 font-medium mt-3">
                      {value.title}
                    </p>
                  </div>

                  <p
                    className="mt-4 text-grey-200"
                    style={{ lineHeight: "26px", fontSize: "15px" }}
                  >
                    {value.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section>
        <div className="bg-dark py-16 text-center">
          <h6 className="text-white font-semibold" style={{ fontSize: "46px" }}>
            Pricing
          </h6>
          <p
            className="text-white w-11/12 md:w-10/12 lg:w-8/12 xl:w-6/12 px-6 mx-auto mt-2"
            style={{ fontSize: "16.7px", lineHeight: "28.5px" }}
          >
            WoodCore gives you the best pricing for a banking system. Smooth
            deployment, easy to use and adaptable too. Woodcore gives you at
            least 50 users for your back office (for more users, contact us).
          </p>
          <button
            className="font-medium px-8 rounded-sm bg-green text-white mt-6 hover:bg-green-dark duration-500"
            style={{ fontSize: "14.7px", height: "52px" }}
            onClick={() => navigate("/pricing")}
          >
            More on pricing
          </button>
        </div>
      </section>
    </Layout>
  )
}

export default FeaturesPage
